var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"dplayer",staticStyle:{"height":"480px"},attrs:{"id":"dplayer"}})
}
var staticRenderFns = []

export { render, staticRenderFns }